module.exports = __webpack_public_path__ + "img/pdf.e0631a8a.png";